<app-loader *ngIf="loading"></app-loader>
<div
  class="p-5 mx-4 sm:mx-[12rem] md:mx-[15rem] lg:mx-[22rem] xl:mx-[28rem] 2xl:mx-[35rem] mt-10 md:mt-24 mb-6"
>
  <div class="gap-10">
    <div class="col-span-1 lg:col-span-4 relative flex justify-center mx-auto">
      <div class="relative flex flex-col w-full h-full mx-auto justify-center">
        <h1
          class="text-primary_Text_Color xl:text-xl 2xl:text-2xl poppinsSemiBold text-left mb-4"
        >
          Profile Registration
        </h1>
        <div
          class="relative flex justify-center items-center rounded-lg overflow-hidden w-full bg-gray-200 h-auto"
        >
          <img
            [src]="_commonService.Images.IMAGE_CAPTURE_LAYOUT"
            alt=""
            class="absolute inset-0 z-50 opacity-60 w-full h-full object-cover"
          />
          <!-- <img src="/assets/images/Union.svg" alt="" class="absolute z-50 w-[58%]" /> -->

          <div *ngIf="errors?.length > 0" class="absolute z-30">
            <img
              [src]="_commonService.Images.ALLOW_ICON"
              alt=""
              class="mx-auto w-[80px] py-5"
            />
            <h1 class="text-2xl text-center pb-3 text-red-600">
              We can't find your camera
            </h1>
            <h3 class="text-secondary_Light_Text_Color text-center">
              {{ errors[0].message }}
            </h3>
          </div>

          <div
            *ngIf="!enableWebCam"
            class="relative z-10 w-full h-full flex justify-center items-center"
          >
            <webcam
              [trigger]="triggerObservable"
              (imageCapture)="handleImage($event)"
              *ngIf="showWebcam"
              [allowCameraSwitch]="allowCameraSwitch"
              [switchCamera]="nextWebcamObservable"
              [videoOptions]="videoOptions"
              (cameraSwitched)="cameraWasSwitched($event)"
              (initError)="handleInitError($event)"
              [height]="webcamHeight"
              [width]="webcamWidth"
            ></webcam>
          </div>
        </div>

        <div
          *ngIf="!enableWebCam"
          class="bg-white pb-6 rounded-b-lg w-full -mt-2"
          style="
            box-shadow: 0px 49px 74px 0px var(--attempt_test_box_shadow);
            border: 1px solid var(--my_profile_subHeading_Border_Color);
          "
        >
          <p class="text-red-600 text-sm pt-4 pb-6 px-4 text-center">
            * Please ensure your face is fully visible and centered within the
            frame for verification. Improper images may lead to disqualification
            or blacklisting.
          </p>
          <!-- btn_text_blue_color -- this was the colour used before replaced it with the default colours used in the entire website -->
          <button
            class="text-primary_Bg_Btn_Text_color 2xl:text-base xl:text-sm font-bold py-3 px-12 rounded-xl bg-primary_Bg_Button_Color  flex gap-2 mx-auto disabled:opacity-50 disabled:cursor-not-allowed"
            (click)="triggerSnapshot()"
            [disabled]="!cameraActive || errors?.length > 0 || !faceModelReady"
          >
            <img [src]="themeBlue?_commonService.Images.CAPTURE_PICTURE_BLUE:_commonService.Images.CAPTURE_PICTURE" alt="" />
            {{ faceModelReady ? 'Take Picture' : 'Initializing...' }}
          </button>
          <p *ngIf="faceValidationMessage && faceDetectionService.isEnabled()" class="text-red-600 text-xs mt-3 text-center">
            {{ faceValidationMessage }}
          </p>
        </div>

        <div
          class="snapshot p-5 bg-white shadow-lg rounded-lg"
          *ngIf="webcamImage"
        >
          <img [src]="webCamImageUrl" class="mx-auto w-auto rounded-lg" />
          <div class="mt-8 flex 2xl:justify-end justify-center">
            <!-- class="text-btn_text_blue_color font-bold py-2 px-4 rounded-xl border-2 border-attempt_test_border_color bg-white_color" -->
            <button
            class="text-primary_Bg_Btn_Text_color 2xl:text-base xl:text-sm font-bold py-3 px-12 rounded-xl bg-primary_Bg_Button_Color flex gap-2"
              (click)="clearImage()"
            >
              Re-Capture
            </button>
            <button
              class="text-primary_Bg_Btn_Text_color 2xl:text-base xl:text-sm font-bold py-3 px-12 rounded-xl bg-primary_Bg_Button_Color flex gap-2 ml-5"
              (click)="saveImage()"
            >
              Submit
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- <div class="col-span-1 lg:col-span-3 mt-11">
		<ul class="list-none">
		  <li class="capture-image-prompt">
			<div class="flex gap-3 text-secondary_Light_Text_Color poppinsMedium">
			  <img src="/assets/images/corrcetImage.svg" alt="" class="h-5 w-5" />
			  <p> Prompt: 1 </p>
			</div>
			<span class="ml-8 line-through text-secondary_Light_Text_Color">Please adjust your face as per the guide</span>
		  </li>
		  <li class="capture-image-prompt">
			<div class="flex gap-3">
			  <img src="/assets/images/bg-blue-cross.svg" alt="" />
			  <p class="text-gray-700"> Prompt: 2 </p>
			</div>
			<span class="ml-8">Too much lighting, avoid window behind</span>
		  </li>
		  <li class="capture-image-prompt">
			<div class="flex gap-3">
			  <img src="/assets/images/bg-blue-cross.svg" alt="" />
			  <p class="text-gray-700"> Prompt: 3 </p>
			</div>
			<span class="ml-8">Another face detected</span>
		  </li>
		  <li class="capture-image-prompt">
			<div class="flex gap-3">
			  <img src="/assets/images/bg-blue-cross.svg" alt="" />
			  <p class="text-gray-700"> Prompt: 4 </p>
			</div>
			<span class="ml-8">Too much noise</span>
		  </li>
		</ul>
	  </div> -->
  </div>
</div>

<!-- <div class="shadow-[0_3px_10px_rgb(0,0,0,0.2)]">
	<div class="text-center pt-3">
		<div class="font-bold text-xl mb-2">Capture Image</div>

	</div>
	<div class="flex justify-center rounded-xl py-5 ">
		<div *ngIf="errors?.length>0">
			<img [src]="_commonService.Images.ALLOW_ICON" alt="" class="mx-auto w-[80px] py-5">
			<h1 class="text-2xl text-center pb-3">
				We can't find your camera
			</h1>
			<h3 class="text-secondary_Light_Text_Color">
				{{errors[0].message}}
			</h3>

		</div>
		<div *ngIf="!enableWebCam" class="m-3">
			<webcam [trigger]="triggerObservable" (imageCapture)="handleImage($event)" *ngIf="showWebcam"
				[allowCameraSwitch]="allowCameraSwitch" [switchCamera]="nextWebcamObservable"
				[videoOptions]="videoOptions" (cameraSwitched)="cameraWasSwitched($event)"
				(initError)="handleInitError($event)"></webcam>
			<br />
			<div class="flex justify-center">
				<app-button [btnType]="'button'" [class]="'text-btn_text_blue_color font-bold py-2 px-4 rounded-xl border-2 mt-5'"
					(buttonClick)="triggerSnapshot();" title="Take Picture">📸 Capture Image</app-button>
			</div>
		</div>
		<div class="snapshot m-3" *ngIf="webcamImage">
			<img [src]="webCamImageUrl" class="mx-auto w-auto" />
				<div class="mt-8 flex justify-center">
					<app-button [class]="'text-btn_text_blue_color font-bold py-2 px-4 rounded-xl border-2 border-attempt_test_border_color bg-[#fff]'"
						(buttonClick)="clearImage()" [innerText]="'Re-Capture'"></app-button>
						<app-button [class]="'text-btn_text_blue_color font-bold py-2 px-4 rounded-xl border-2 border-attempt_test_border_color bg-[#fff] ml-5'"
						(buttonClick)="saveImage()" [innerText]="'Submit'"></app-button>
			</div>
		</div>
	</div>
</div> -->
